import React from "react";
import { HomeSec } from "./home";

export const Home = () => {
  return (
    <React.Fragment>
      <div className="banner-main">
        <HomeSec />
      </div>
    </React.Fragment>
  );
};
